(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallResultDialogController', PhoneCallResultDialogController);

    PhoneCallResultDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PhoneCallResult', 'PhoneCallResultGroup'];

    function PhoneCallResultDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PhoneCallResult, PhoneCallResultGroup) {
        var vm = this;

        vm.phoneCallResult = entity;
        vm.clear = clear;
        vm.save = save;
        vm.phonecallresultgroups = PhoneCallResultGroup.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.phoneCallResult.id !== null) {
                PhoneCallResult.update(vm.phoneCallResult, onSaveSuccess, onSaveError);
            } else {
                PhoneCallResult.save(vm.phoneCallResult, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:phoneCallResultUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
